import m from "../../geodata/es2015/slovakiaLow";
window.am4geodata_slovakiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/slovakiaLow.js
// module id = null
// module chunks = 